import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPolyComponent } from './simple-icons-poly.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPolyComponent ],
    exports:      [ SimpleIconsPolyComponent ],
    bootstrap:    []
})
export class SimpleIconsPolyModule {}
